// eslint-disable-next-line import/prefer-default-export
export const SLACK_SERVICE_NAME = 'slack';

export const USER_TYPE = 'user';
export const WORKSPACE_TYPE = 'workspace';
